export default function WhatsAppButton() {

  const phone = "8122875500"

  const message = "Hello, I would like to know more about your services."

  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`

  return (

<a
href={whatsappUrl}
target="_blank"
rel="noopener noreferrer"
className="animate-pulse fixed bottom-6 right-6 z-50 flex items-center justify-center w-16 h-16 rounded-full bg-green-500 hover:bg-green-600 shadow-lg transition"

>

<img
src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
alt="WhatsApp"
className="w-8 h-8 "

/>


</a>

  )

}
